(ns app.domain.model-codes.model
  (:require [clojure.string :as str]
            [core.db.child-entity :as child]
            [core.db.entity.util :as eu]))

(def item-type-with-children? #{:model-code-src-item/section
                                :model-code-src-item/chapter
                                :model-code-src-item/book})

(defn format-ordinal+title [ordinal title]
  (->> [ordinal title]
       (remove str/blank?)
       (str/join " ")))

(defn api-item-label-with-ordinal [{:keys [ordinal title]}]
  (format-ordinal+title ordinal title))

(defn model-code-item-label-with-ordinal [{:model-code-item/keys [ordinal title]}]
  (format-ordinal+title ordinal title))

(def ^{:arglists '([model-code-item])} item-sections
  (child/child-entities-of-type-fn :entity.type/model-code-section))

(def ^{:arglists '([model-code-item])} item-contents
  (child/child-entities-of-type-fn :entity.type/model-code-content))

(def ^{:arglists '([model-code-item])} can-have-sections?
  (eu/is-type-fn :entity.type/model-code-book :entity.type/model-code-section))

(def ^{:arglists '([model-code-item])} can-have-content-items?
  (eu/is-type-fn :entity.type/model-code-section))

(defn item-descendants [model-code-item]
  (concat (when (can-have-sections? model-code-item)
            (let [subsections (item-sections model-code-item)]
              (concat subsections
                      (mapcat item-descendants subsections))))
          (when (can-have-content-items? model-code-item)
            (item-contents model-code-item))))

(defn item-children [model-code-item]
  (concat (when (can-have-sections? model-code-item)
            (item-sections model-code-item))
          (when (can-have-content-items? model-code-item)
            (item-contents model-code-item))))
